import React from 'react'

import { Rating } from '../rating/Rating'
import { GoogleRatingOutputDto } from '../../../lib/graphql'

interface RatingsProps {
  nabooRating?: {
    rating?: number | null | undefined
    ratingsTotal?: number | null | undefined
  } | null
  googleRating?: GoogleRatingOutputDto | null
  small?: boolean
}

export const Ratings: React.FC<RatingsProps> = ({
  nabooRating,
  googleRating,
  small,
}) => {
  const showSeparator = nabooRating?.rating && googleRating?.rating

  return (
    <div className='flex items-center gap-2'>
      {nabooRating && (
        <Rating
          rating={nabooRating.rating}
          userRatingsTotal={nabooRating.ratingsTotal}
          isNabooRating
          small={small}
        />
      )}
      {showSeparator && <div>|</div>}
      {googleRating && (
        <Rating
          rating={googleRating.rating}
          userRatingsTotal={googleRating.userRatingsTotal}
          inverseStarAndRating
          small={small}
        />
      )}
    </div>
  )
}
